import React, {useState} from "react";
import ImageUploading from "../../../../ComponentsForked/react-images-uploading/src/index";
import {ErrorsType, ImageListType} from "react-images-uploading/dist/typings";
import {Button} from "react-bootstrap";
import * as Sentry from "@sentry/react";
import withReactContent from "sweetalert2-react-content";
import Swal from "sweetalert2";
import {SWAL_ALERT_DEFAULTS} from "../../../../Utils/defaults";
import {useAppSelector} from "../../../../store/hooks";
import {MAX_SLIDES} from "../../../../Utils/maxSlides";

interface UploadProps {
    onUpload: (imageList: ImageListType) => void,
}

const Upload: React.FC<UploadProps> = ({onUpload}) => {

    const makerData = useAppSelector(state => state.makerData)
    const [images, setImages] = useState<ImageListType>([]);
    const acceptTypes = ['jpg', 'jpeg', 'png', 'heic', 'heif', 'tiff', 'webp', 'bmp', 'gif', 'avif'];
    const maxFileSize = 42000000; //40000000

    const onImageUploadingChange = async (imageList: ImageListType, addUpdateIndex?: Array<number>) => {

        if (makerData.slides.length + imageList.length - 1 > MAX_SLIDES) {
            const MySwal = withReactContent(Swal)
            MySwal.close()
            MySwal.fire({
                ...SWAL_ALERT_DEFAULTS,
                title: '',
                text: 'В проект можно добавить не более ' + MAX_SLIDES + ' слайдов.',
                icon: 'info'
            });
            return;
        }

        let maxFileSize = false;
        let acceptType = false;
        for (const imageItem of imageList) {
            if (typeof imageItem.error === 'undefined') {
                // без ошибок
            } else {
                if (imageItem.error?.maxFileSize == true) {
                    maxFileSize = true;
                }
                if (imageItem.error?.acceptType == true) {
                    acceptType = true;
                }
            }
            /**
             * Вручную проверяем тип файла, что тип начинается на image/
             * т.к. на мобильных устройствах всё-таки можно выбрать видео для загрузки (и другие файлы)
             */
            if (!imageItem.file?.type.startsWith('image/')) {
                acceptType = true;
                imageItem.error = {acceptType: true} as ErrorsType;
            }
        }

        // data for submit
        setImages(imageList);

        onUpload(imageList);

        if (maxFileSize || acceptType) {
            let swalMessage = '';
            if (maxFileSize && acceptType) {
                swalMessage = 'Некоторые файлы не были загружены. Можно загружать только фотографии, размером не больше 40Мб.';
            } else if (maxFileSize) {
                swalMessage = 'Некоторые файлы не были загружены. Можно загружать фотографии, размером не больше 40Мб.';
            } else if (acceptType) {
                swalMessage = 'Некоторые файлы не были загружены. Можно загружать только фотографии.';
            }

            const MySwal = withReactContent(Swal)
            MySwal.close()
            MySwal.fire({
                ...SWAL_ALERT_DEFAULTS,
                title: '',
                text: swalMessage,
                icon: 'info'
            });
        } else {
            const MySwal = withReactContent(Swal)
            MySwal.close()
        }
    };

    const onImageUploadingError = (errors: ErrorsType, files?: ImageListType) => {
        let errorTitleSwal = 'Произошла ошибка при сохранении проекта, попробуйте ещё раз.';

        if (errors?.maxNumber === true) {
            errorTitleSwal = 'Слишком много файлов. Максимум - ' + MAX_SLIDES + ' фотографий.';
        } else if (errors?.acceptType === true) {
            errorTitleSwal = 'Некоторые файлы не были загружены. Можно загружать только фотографии.';
        } else if (errors?.maxFileSize === true) {
            errorTitleSwal = 'Некоторые файлы не были загружены. Можно загружать фотографии, размером не больше 40Мб.';
        } else if (errors?.resolution === true) {
            //
        }

        // Sentry.captureException(
        //     new Error(errorTitle),
        //     {
        //         extra: {
        //             errors: errors,
        //             numberFilesUpload: files?.length
        //         }
        //     }
        // )

        const MySwal = withReactContent(Swal);
        MySwal.fire({
            ...SWAL_ALERT_DEFAULTS,
            title: '',
            text: errorTitleSwal,
            icon: 'info'
        });
    }

    return (
        <div className={'tab-upload'}>
            <ImageUploading
                multiple={true}
                value={images}
                onChange={onImageUploadingChange}
                onError={onImageUploadingError}
                dataURLKey="data_url"
                acceptType={acceptTypes}
                maxFileSize={maxFileSize}
                maxNumber={MAX_SLIDES}
                inputProps={{accept: "image/*,.heic,.heif"}}
            >
                {({
                      imageList,
                      onImageUpload,
                      onImageRemoveAll,
                      onImageUpdate,
                      onImageRemove,
                      isDragging,
                      dragProps,
                  }) => (
                    // write your building UI
                    <div className="upload__image-wrapper">
                        <div
                            className={
                                `drop-area ${isDragging ? 'is-dragging' : ''}`
                            }
                            onClick={onImageUpload}
                            {...dragProps}
                        >
                            <div className={'upload-circle'}>
                                <i className={'fa fa-upload'}></i>
                            </div>
                            <div className={'hint'}>
                                Перетащите фотографии сюда <br/>или нажмите кнопку "Выбрать фотографии".
                            </div>
                            <Button className={'select-photos-btn'}>Выбрать фотографии</Button>
                            <div className={'hint2'}>
                                Загруженные фотографии хранятся <b>30 дней</b>.
                            </div>
                        </div>
                    </div>
                )}
            </ImageUploading>
        </div>
    )
}

export default Upload;